import { render } from "./AppController.vue?vue&type=template&id=30fc91b7&scoped=true"
import script from "./AppController.vue?vue&type=script&lang=js"
export * from "./AppController.vue?vue&type=script&lang=js"

import "./AppController.vue?vue&type=style&index=0&id=30fc91b7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fc91b7"]])

export default __exports__